<div class="pop-bg">
</div>

<div class="pop-position">
  <div class="row grey p-0 header-popup-box">
    <span class="col-md-10 col-sm-10 p-0">
      <div class="heading-panel">
        <span class="text-sm text-ellipsis heading-txt flex ml-10">Allocation/Re-Allocation</span>
      </div>
    </span>
    <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor">
      <i class="fa fa-times" (click)="dismissModel()"></i>
    </span>
  </div>
  <div class="body">
    <div [ngClass]="{'activeGrid' : showReAllocation==true}" class="gridView p-0">
      <h4 style="padding-left: 1rem;font-weight: 600;">Allocated Accounts</h4>
      <div class="sticky-table sticky-ltr-cells border-0 table-hight">
        <ag-grid-angular [enableSorting]="true" [enableFilter]="true" class="ag-theme-balham grid-w" [rowData]="rowData"
          [columnDefs]="columnDefs" [rowSelection]="rowSelection" [suppressColumnVirtualisation]="true"
          [suppressDragLeaveHidesColumns]="true" [suppressDragLeaveHidesColumns]="true"
          (gridReady)="onGridReady($event)" (cellClicked)="getData($event)">
        </ag-grid-angular>
      </div>
    </div>

    <div class="formView" *ngIf="showReAllocation==true">
      <h4>Re-Allocate Accounts</h4>
      <form id="allocatedForm" *ngIf="agentList && agentList.length>0">
        <div class="form-group mt-10">
          <label class=" label-std control-label p-0 b-600 pl-0" for="">Agent</label>
          <ng-multiselect-dropdown [placeholder]="'Select Agent'" [settings]="clientSetting" [data]="agentList"
            [(ngModel)]="selectedAgentList" [ngModelOptions]="{standalone: true}">
          </ng-multiselect-dropdown>
        </div>
        <button type="button" class="mt-3 btn blue square-btn blue-hover btn-txt mr-10 btn-default" style="margin-left: 40%"
          (click)="allocateAccount()"
          [disabled]="selectedAgentList==null || selectedAgentList.length==0 || submitStatus==true">Allocate</button>
      </form>
      <h4 *ngIf="agentList.length==0">Checking Un-Worked Account List</h4>
    </div>
  </div>
</div>
